import {
  ADD_PARTICIPANT_SELECT,
  ADD_PARTICIPANT_FORM_FOCUSED,
  CLEAR_PARTICIPANT_ADD_LIST
} from 'constants/AddParticipantDrawer';

export function selectContactForCall(contact) {
  return {
    type: ADD_PARTICIPANT_SELECT,
    payload: contact
  };
}

export function setFormFocus(isFocused) {
  return {
    type: ADD_PARTICIPANT_FORM_FOCUSED,
    payload: isFocused
  };
}

export function clearAddList() {
  return {
    type: CLEAR_PARTICIPANT_ADD_LIST
  };
}

export default {
  selectContactForCall,
  setFormFocus,
  clearAddList
};
